<template>
  <div id="colorList">
    <button
      class="textureLine text-left text-base"
      v-for="item of dressing.assets.assets2D"
      :key="item.id"
      @click="newColor(item.id)"
      :style="{ 'background-image': `url(./colors/${dressing.assets.assets2D[item.id].file})` }"
    >
      <p class="p-4">{{ item.name }}</p>
    </button>
  </div>
</template>

<script>
import Dressing from '../../utils/webgl/Dressing.js';

export default {
  name: 'TextureConfig',
  data() {
    return {
      singleColor: true,
      selectedItem: 0,
      selectedContent: 0,
      dressing: new Dressing(),
    };
  },
  methods: {
    elementSelected(boxID, contentID) {
      this.selectedItem = boxID;
      this.selectedContent = contentID;
    },
    newColor(colorID) {
      if (this.singleColor) {
        this.dressing.newGlobalColor(colorID);
        this.$emit('newGlobalColor', colorID);
      }
    },
  },
};
</script>

<style scoped>
#elementList {
  display: flex;
  flex-direction: column;
}

.selected {
  background-color: #993973 !important;
}

.textureLine {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  background-size: 25% 100%;
  background-repeat: repeat-x;
}

.textureLine:hover {
  background-color: #c0c0c0;
}

.textureLine p {
  color: white;
  width: 100%;
  text-shadow: 0 0 5px black;
  background: linear-gradient(-90deg, rgba(255, 255, 255, 0%) 0%, rgba(0, 0, 0, 0.5) 100%);
}

#colorList {
  height: calc(100% - 3.25rem);
  overflow-y: scroll;
}
</style>
